export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];
export const listTitle = [
    {
        title: 'Создали платформу для национального&nbsp;конкурса по&nbsp;ИИ в&nbsp;медицине',
        subtitle:
            'Разработали высоконагруженную платформу для конкурсов AI&rsquo;m&nbsp;Finder и&nbsp;AI&rsquo;m Doctor и&nbsp;сформировали уникальные датасеты для обучения российских ИИ-систем, которые станут основой системы поддержки принятия врачебных решений.',
        description: [
            {
                name: 'Отрасль',
                details: 'Инновации',
            },
            {
                name: 'Услуги',
                details: 'Разработка платформы',
            },
            {
                name: 'Сроки',
                details: 'октябрь 2022 – ноябрь 2023',
            },
        ],
        company: 'Фонд Национальной технологической инициативы (НТИ)\n',
        companyLink: 'https://upgreat.one/',
        companyLinkName: 'upgreat.one',
        text: 'Фонд организует технологические конкурсы, инженерные соревнования для команд разработчиков, которые предлагают решения критически важных задач в&nbsp;различных сферах, которые имеют критически важное значения для развития технологического рынка России.',
    },
];

export const listStages = [
    {
        number: '1.',
        text: 'Разработать и реализовать систему датасетов с эпикризами пациентов.',
    },
    {
        number: '2.',
        text: 'Валидировать датасеты врачами-экспертами.',
    },
    {
        number: '3.',
        text: 'Реализовать систему разметки эпикризов врачами прямо в&nbsp;браузере.',
    },
    {
        number: '4.',
        text: 'Создать платформу для проведению технологического конкурса.',
    },
    {
        number: '5.',
        text: 'Реализовать сложный модуль математики, который позволит сравнить разметку команд с&nbsp;помощью&nbsp;ИИ и&nbsp;действия врачей.',
    },
];

export const iconsBlock = [
    {
        title: 'Неполное техническое задание',
        description:
            'Глубинно проработали взаимосвязи ролей, что дало понимание бэкенд-команде о&nbsp;структуре взаимодействия баз данных и&nbsp;модулей системы, облегчило работу фронтенду по&nbsp;синхронизации визуальных сценариев с&nbsp;внутренней логикой.',
        icon: "/images/svg/aimed/icon1.svg",
    },
    {
        title: 'Неоднородность данных',
        description:
            'Университет им. Сеченова предоставил огромный массив данных с&nbsp;эпикризами, но&nbsp;в&nbsp;оригинальных медицинских документах нет единого стандарта. Партнеры из&nbsp;университета универсализировали данные, а&nbsp;мы&nbsp;написали скрипт, чтобы на&nbsp;входе их&nbsp;валидировать.',
        icon: "/images/svg/aimed/icon2.svg",
    },
    {
        title: 'Кодирование большого массива&nbsp;матданных',
        description:
            'Разработали математический аппарат для сравнения результатов участников с&nbsp;эталоном. Формулы предоставили ученые-математики, которые&nbsp;мы переводили на&nbsp;язык программирования.',
        icon: "/images/svg/aimed/icon3.svg",
    },
    {
        title: 'Строгая конфиденциальность данных',
        description:
            'Для сохранности и&nbsp;конфиденциальности данных ограничили действия пользователи разного уровня только в&nbsp;рамках своей задачи. Для защиты от&nbsp;массовых ddos-атак закрыли внешний доступ к&nbsp;базе данных.',
        icon: "/images/svg/aimed/icon4.svg",
    },
];

export const listCompetitions = [
    {
        description:
            'участники беспрепятственно раз в&nbsp;минуту все одновременно получали файлы для&nbsp;работы;',
    },
    {
        description: 'принимали и&nbsp;фиксировали ответы участников;',
    },
    {
        description:
            'на&nbsp;лидерборде в&nbsp;прямом эфире без обновления страницы отображали прогресс по&nbsp;каждой команде-участнику;',
    },
    {
        description: 'оперативно реагировали на&nbsp;любые ситуации.',
    },
];

export const listResults = [
    {
        title: '6 месяцев',
        description: 'от&nbsp;утверждения дизайна до&nbsp;запуска платформы',
    },
    {
        title: '3 851 эпикриз',
        description: 'загрузили в&nbsp;систему для обработки медэкспертами',
    },
    {
        title: '8 ЛК',
        description: 'разработали для разных ролей на&nbsp;платформе',
    },
    {
        title: '100 минут',
        description: 'бесперебойной работы в&nbsp;финале AI&rsquo;m&nbsp;Finder',
    },
];

export const listMedia = [
    {
        title: 'В&nbsp;России выберут лучшую ИИ-систему анализа протоколов медосмотров',
        subtitle: 'ТАСС',
        icon: "/images/svg/aimed/media1.svg",
        link: 'https://nauka.tass.ru/nauka/14666135?utm_source=yandex.ru&utm_medium=organic&utm_campaign=yandex.ru&utm_referrer=yandex.ru',
    },
    {
        title: 'Конкурс AI&rsquo;m Doctor&nbsp;&mdash; путь разработчика',
        subtitle: 'SKOLKOVO',
        icon: "/images/svg/aimed/media2.svg",
        link: 'https://sk.ru/news/konkurs-aim-doctor-put-razrabotchika/',
    },
    {
        title: 'Доктор Что: искусственный интеллект помогает врачам',
        subtitle: 'TechInsider',
        icon: "/images/svg/aimed/media3.svg",
        link: 'https://www.techinsider.ru/science/1569335-doktor-chto-iskusstvennyy-intellekt-pomogaet-vracham/',
    },
];

export const listSolutions = [
    {
        description:
            'Продумали архитектуру платформы для конкурсных испытаний с&nbsp;учетом высокой одномоментной нагрузки.',
    },
    {
        description: 'Создали дизайн-макеты для ключевых разделов.',
    },
    {
        description:
            'Прописали функциональные требования и&nbsp;спроектировали личные кабинеты для&nbsp;8&nbsp;ролей пользователей (участник, эксперт-медик, администратор и&nbsp;тд).',
    },
    {
        description:
            'Разработали базовую схему и&nbsp;структуру по&nbsp;обеспечению информационной безопасности проекта.',
    },
];

export const listSolutionsRoles = [
    {
        description: 'Разработали модуль регистрации и&nbsp;авторизации пользователей.',
    },
    {
        description: 'Запустили в&nbsp;работу модуль &laquo;Справочник симптомов&raquo;.',
    },
    {
        description:
            'Сделали специальный разметчик для классификации симптомов в&nbsp;карточках пациентов и&nbsp;передали его в&nbsp;тестирование экспертам-медикам.',
    },
    {
        description:
            'Загрузили на&nbsp;платформу и&nbsp;передали на&nbsp;разметку эпикризы пациентов.',
    },
    {
        description:
            'Подготовили проект для тестирования в&nbsp;объеме разработанного функционала.',
    },
];

export const listMarker = [
    {
        description:
            'Разработали сервис со&nbsp;сложными математическими расчетами для автоматического вычисления результатов конкурса на&nbsp;основе интегрального критерия. Подготовкой математики подсчёта результата занималась отдельная группа экспертов, в&nbsp;том числе из&nbsp;Сеченовского университета.',
    },
    {
        description:
            'Написали утилиту для обеспечения взаимодействия платформы и систем участников.',
    },
    {
        description:
            'Спроектировали и&nbsp;передали в&nbsp;эксплуатацию систему проверки решений и&nbsp;систему испытаний. После регистрации каждый участник в&nbsp;личном кабинете мог пройти тренировочное тестирование своего ИИ-решения и&nbsp;получить результат по&nbsp;тем&nbsp;же критериям, которые будут в&nbsp;основных соревнованиях.',
    },
    {
        description:
            'Загрузили на платформу информацию с историями болезней. Врачи заранее поработали с этими карточками и с помощью специального разметчика, разработанного нами, выделили симптомы болезней по каждому пациенту и подтвердили, либо опровергли установленный диагноз.',
    },
    {
        description: 'Добавили к&nbsp;функционалу платформу модули Отчетности и&nbsp;Лидерборд.',
    },
    {
        description:
            'Разработали и&nbsp;передали в&nbsp;эксплуатацию личные кабинеты пользователей со&nbsp;всеми типами ролей.',
    },
];

export const listMarkerStages = [
    {
        description:
            'Настроили облачную систему через сервис Яндекс.Облако для обеспечения отказоустойчивости платформы.',
    },
    {
        description:
            'Сделали форму обратной связи и&nbsp;подключили к&nbsp;ней Telegram-бота. Вопросы от&nbsp;участников отправлялись на&nbsp;почту и&nbsp;дублировались с&nbsp;помощью бота в&nbsp;чат, где были ответственные лица по&nbsp;каждому направлению. Вопросы могут быть не&nbsp;только по&nbsp;работе платформы или условиям конкурса, но&nbsp;и&nbsp;по&nbsp;медицине.',
    },
    {
        description:
            'Сделали стресс-тестирование платформы, имитировав нагрузку в&nbsp;10&nbsp;раз больше, чем запланировано в&nbsp;дни финальных испытаний. Провели отборочный этап основного конкурса и&nbsp;конкурса-сателлита.',
    },
    {
        description:
            'Организовали тренировочные испытания для команд-участниц конкурсов. Каждому участнику система автоматически отправляла результаты испытаний аналогичные тем, которые они получат в&nbsp;рамках финала.',
    },
    {
        description:
            'Подготовили платформу к&nbsp;финальным испытаниям конкурса-сателлита AI&rsquo;m Finder с&nbsp;учетом высокой одномоментной нагрузки.',
    },
];
